<template>
	<div class="myqun">
		<div class="headtt">
			<span class="icon iconfont" @click="go()">&#xe601;</span>
			<b @click="go()" v-if="shareData.ms_type=='1'">分享到群</b>
			<b @click="go()" v-if="shareData.ms_type=='2'">分享频道</b>
		</div>
		<div class="loding" v-loading="true" v-if="listData.length==0"></div>
		<div class="ul">
			<div class="li" v-for="item in listData" @click="shares(item)">
				<img :src="item.headImg" />
				<div class="name">{{item.group_name}}</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { Base64 } from '@/xiaomi/Base64.js';
	import { getMimcInfo } from '@/xiaomi/mimc.js';
	import qs from "qs"
	export default {
		data() {
			return {
				listData: [],
				shareData: '',
				loading: true,
			}
		},
		computed: {
			user() {
				return this.$store.state.user
			}
		},
		methods: {
			go() {
				this.$parent.closeQun();
			},
			getData(data) {
				this.shareData = data
				this.getQunList()
			},
			getQunList() {
				var type = 'group'
				if (this.shareData.ms_type == '1') {
					type = 'group'
				} else if (this.shareData.ms_type == '2') {
					type = 'channel'
				}
				let params = qs.stringify({
					group_type: type,
				})
				this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
				this.$axios.post('/goods/mimc/v1/queryMyGroups', params)
					.then(userData => {
						if (userData.data.resultCode == '0000') {

							if (this.shareData.ms_type == '1') {
								userData.data.resultInfo.my.filter((item) => {
									if (this.shareData.msg_to_account != item.group_id) {
										this.listData.push(item)
									}
								})
								userData.data.resultInfo.in.filter((item) => {
									if (this.shareData.msg_to_account != item.group_id) {
										this.listData.push(item)
									}
								})
							} else if (this.shareData.ms_type == '2') {
								userData.data.resultInfo.my.filter((item) => {
									if (this.shareData.msg_to_account != item.group_id) {
										this.listData.push(item)
									}
								})
							}

						} else {
							this.$message.error(userData.data.resultMsg);
						}

					}).catch(error => {

						console.log(error)
					})
			},
			getCookie(c_name) {
				//判断document.cookie对象里面是否存有cookie
				if (document.cookie.length > 0) {
					var c_start = document.cookie.indexOf(c_name + "=")
					//如果document.cookie对象里面有cookie则查找是否有指定的cookie，如果有则返回指定的cookie值，如果没有则返回空字符串
					if (c_start != -1) {
						c_start = c_start + c_name.length + 1
						var c_end = document.cookie.indexOf(";", c_start)
						if (c_end == -1) c_end = document.cookie.length
						return unescape(document.cookie.substring(c_start, c_end))
					}
				}
				return ""
			},
			shares(itemData) {


				var message_
				if (this.shareData.biz_type == 'PIC_FILE') {
					message_ = Base64.encode(JSON.stringify(this.shareData.msg_content));
				} else if (this.shareData.biz_type == 'PIC_FILES') {
					if (this.shareData.msg_content.content != '') {
						this.shareData.msg_content.content = this.encodeUnicode(this.shareData.msg_content.content)
					}
					message_ = Base64.encode(JSON.stringify(this.shareData.msg_content));
				} else if (this.shareData.biz_type == "TEXT") {
					this.shareData.msg_content.content = this.encodeUnicode(this.shareData.msg_content.content)
					message_ = Base64.encode(JSON.stringify(this.shareData.msg_content));
				} else if (this.shareData.biz_type == "VIDEO_FILE") {
					message_ = Base64.encode(JSON.stringify(this.shareData.msg_content));
				} else if (this.shareData.biz_type == "GOODS") {
					message_ = Base64.encode(JSON.stringify(this.shareData.msg_content));
				} else if (this.shareData.biz_type == "MUSIC") {
					message_ = Base64.encode(JSON.stringify(this.shareData.msg_content));
				} else if (this.shareData.biz_type == "CARD") {
					message_ = Base64.encode(JSON.stringify(this.shareData.msg_content));
				}

				var timestampUser = String(new Date().valueOf())
				var jsonMsg = String(JSON.stringify({
					version: 0,
					msgId: this.randomString(5) + "_" + 1,
					timestamp: timestampUser,
					payload: message_,
					nickname: JSON.parse(this.getCookie("userInfo")).title,
					logo: JSON.parse(this.getCookie("userInfo")).logo,
					conNum: JSON.parse(this.getCookie("userInfo")).conNum
				}));
				if (this.shareData.ms_type == '1') {
					this.user.sendGroupMessage(itemData.group_id, jsonMsg, this.shareData.biz_type);
				} else if (this.shareData.ms_type == '2') {
					this.user.sendUnlimitedGroupMessage(itemData.group_id, jsonMsg, this.shareData.biz_type);
				}
				this.$parent.closeQun();
				this.$message("已分享");













			},
			encodeUnicode(str) {
				//加码
				var res = [];
				for (var i = 0; i < str.length; i++) {
					res[i] = ("000" + str.charCodeAt(i).toString(16)).slice(-4);
				}
				return "\\u" + res.join("\\u");
			},
			decodeUnicode(str) {
				//解码
				str = str.replace(/\\/g, "%"); return unescape(str);
			},
			randomString(len) {
				len = len || 32;
				var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
				var maxPos = $chars.length;
				var pwd = '';
				for (var i = 0; i < len; i++) {
					pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
				}
				return pwd;
			},
		},
		created: function () {

		}
	}
</script>
<style scoped>
	.loding {
		position: absolute;
		left: 0;
		top: 35px;
		width: 100%;
		height: 250px;
		background: #FFFFFF;
	}

	.myqun {
		position: absolute;
		left: 0;
		top: 0;
		bottom: 0;
		right: 0;
		z-index: 1000;
		background: #FFFFFF;
		overflow: auto;
		padding: 15px;
		padding-top: 40px;
	}

	.headtt {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		cursor: pointer;
		padding: 10px;
	}

	.myqun .ul {}

	.myqun .ul .li {
		display: flex;
		padding: 0px 25px;
		line-height: 50px;
		align-items: center;
		border-bottom: 1px #f1f1f1 solid;
	}

	.myqun .ul .li img {
		width: 40px;
		height: 40px;
		border-radius: 6px;
	}

	.myqun .ul .li .name {
		padding-left: 25px;
	}
</style>


// WEBPACK FOOTER //
// src/components/im/qun.vue